const properties = {
  /**
   * 全选/全部 key
   */
  SELECT_ALL: 0,
  /**
   * 市场分类 key
   */
  MARKET_CATEGORY: 4,
  /**
   * 产品分类 key
   */
  PRODUCT_CATEGORY: 5,
  /**
   * 产品细分 key
   */
  PRODUCT_SUBDIVIDE: 52,
};

export default properties;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSFilterPanel/properties.ts